import { CreateItemActionCreatorOptions, resources } from 'redux-and-the-rest';
import { RewardPositionModel } from '../../models/rewardPositionModel';
import Env from '../../utils/env';
import { userActions } from './userReducer';
import generateClientId from './utils/generateClientId';

const {
  reducers: rewardPositionReducer,
  fetchList: fetchRewardPositions,
  getOrFetchList: getOrFetchRewardPositions,
  createItem: createRewardPosition,
  updateItem: updateRewardPosition,
  destroyItem: deleteRewardPosition,
  buildInitialState: buildInitialRewardPositions,
} = resources<RewardPositionModel>(
  {
    name: 'rewardPositions',
    url: `${Env.API_URL}/islands/:islandId/reward_positions/:id?`,
    keyBy: 'id',
    clearOn: [
      userActions.clearItem as string,
    ],
  },
  {
    fetchList: true,
    createItem: true,
    updateItem: true,
    destroyItem: true,
  },
);

const INCLUDES = 'gameScore.chosenReward';

const abstractCreateRewardPosition = (
  { islandId }: { islandId: string },
  attributes: Omit<RewardPositionModel, 'id' | 'relationshipNames' | 'type'>,
  options?: CreateItemActionCreatorOptions<RewardPositionModel>,
): void => {
  createRewardPosition({
    islandId,
    include: INCLUDES,
  }, {
    /**
     * Does not work without specifying the parent relationship.
     */
    relationshipNames: ['gameScore', 'gameScore.chosenReward'],
    type: 'rewardPosition',
    id: generateClientId(),
    ...attributes,
  } as RewardPositionModel, {
    push: [{ islandId }],
    ...options,
  });
};

export {
  rewardPositionReducer,
  fetchRewardPositions,
  abstractCreateRewardPosition as createRewardPosition,
  updateRewardPosition,
  deleteRewardPosition,
  getOrFetchRewardPositions,
  buildInitialRewardPositions,
};
